if(jQuery("div").hasClass("table-type-simple")){
  jQuery("table").addClass("usa-table--borderless");
}

// Removes empty space from table cells
jQuery('td').each(function(){
  jQuery(this).html(jQuery(this).html().replace(/&nbsp;/gi,''));
});

// Removes empty space from table cells
jQuery('td').each(function(){
  jQuery(this).html(jQuery(this).html().replace(/&nbsp;/gi,''));
});
// Giving newsletter images an inline style for email styling purposes
jQuery('#newsletter-content img').css({'max-width':'100%'});
// Make Tables Responsive
//exclude on Newsletter Page
var newsletterPage = jQuery( ".newsletter-table" ).length;
jQuery('table').each(function() {
var responsive = jQuery(this).hasClass('table');
if (responsive == false && newsletterPage == 0) {
  jQuery(this).addClass('table').wrap('<div class="table-responsive dol-table"></div>');
}
});